export enum ETopBetsStatus {
  initial = 'initial',
  pending = 'pending',
  success = 'success',
  fail = 'fail',
}
